const t = (e) => e ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e) : !1;
export {
  t as isEmailValid
};
